'use client';

import { Link } from '@/components/ui/Link';
import { Button } from '@/components/ui/buttons/Button';
import { useTranslation } from '@/features/i18n';
import { AddToWatchListButton } from '@/features/watchlist';
import { FadeOutOverlay } from '@/ui/FadeOutOverlay';
import { Artwork } from '@/ui/images/Artwork';
import { ArtworkLogo } from '@/ui/images/ArtworkLogo';
import { CuratedCategoryType } from '@vimond/services/content-discovery';
import { cn } from '@vimond/theme/tailwind';
import { useRouter } from 'next/navigation';

type Props = {
  category: CuratedCategoryType;
};

export const CategoryHero = ({
  category,
  className,
}: Props & React.ComponentPropsWithoutRef<'section'>) => {
  const { t } = useTranslation();
  const router = useRouter();
  return (
    <section
      className={cn(
        'border-background-secondary box-content cursor-pointer',
        className && className,
      )}
      onClick={() => router.push(`/category/${category.id}`)}
    >
      <div className="h-hero relative flex w-full flex-col">
        {category.content?.images?.defaultUrl && (
          <Artwork
            alt=""
            src={category.content.images.defaultUrl}
            location="portal-landscape-cover"
            fallbackToDefault
            fill
            sizes="100vw"
            priority
            className="object-cover object-top"
          />
        )}
        <FadeOutOverlay />
        <div className="animate-fade-in text-shadow absolute bottom-0 left-2 p-5 text-left text-white lg:bottom-[5%] lg:left-10">
          {category.content?.images?.defaultUrl && (
            <ArtworkLogo src={category.content?.images?.defaultUrl} />
          )}
          <h1 className="text-shadow text-3xl font-bold">
            {category.content?.title ?? category.title}
          </h1>
          <div className="my-4 flex gap-2">
            <Link href={`/category/${category.id}`}>
              <Button variant="primary" icon="info">
                {t('more-info')}
              </Button>
            </Link>
            <AddToWatchListButton category={category} />
          </div>
        </div>
      </div>
    </section>
  );
};
